export const APP_VERSION: string = '2.0.14';

export const BUILD_VERSION: string = '2';

export const API_PHP_URL_PART: string = 'api/snapfix/index.php?action=';

export const API_PHP_URL_PART_WEB: string = 'api/snapfix/web/index.php?action=';

export const GOOGLE_API_KEY: string = 'AIzaSyCCUFO4k2VgT53uDCdzWVwiPgUsKKcSQmw';

export const basicAuthConfig = {
    username: 'snapfix',
    password:'snappyfix@123'
};

export const userType = {
	Admin: '1bfdbc8f-e625-4739-be10-83cb7f52b83f',
	User: 'f9696aba-a38b-4e98-b4aa-e45980d011f5'
};

export const adminUsers = [
	'artem@snapfix.com',
	'cathal@snapfix.com',
	'umesh@snapfix.com',
	'kevin@snapfix.com',
	'sunny@snapfix.com',
	'martin@snapfix.com'
];

export const technologyGroupUsers = [
	...adminUsers,
	'akash@snapfix.com',
	'hardik@snapfix.com',
	'jigar@snapfix.com',
	'milan@snapfix.com',
	'pratik@snapfix.com',
	'rajan@snapfix.com',
	'ravi@snapfix.com',
	'sagar@snapfix.com'
];